import { Component, Input, OnInit } from '@angular/core';
import { AppInfoService } from 'core/app-info/app-info.service';
import { AppLocalization } from 'src/app/modules/shared/entities/app-localization';

@Component({
  selector: 'app-invoice-header',
  templateUrl: './invoice-header.component.html',
  styleUrls: ['./invoice-header.component.scss'],
  standalone: false
})
export class InvoiceHeaderComponent implements OnInit {
  appStrings: AppLocalization;
  dateFormat: string;
  @Input() invoiceHeaderResult;

  constructor(
    private appInfoService: AppInfoService,

  ) { }

  ngOnInit() {
    this.appStrings = this.appInfoService.appStrings;
    this.dateFormat = this.appInfoService.dateFormat;
  }

}
